module.exports = __webpack_public_path__ + "static/media/mesut-kaya-eOcyhe5-9sQ-unsplash.80b3848d.webp";